<app-admin-header></app-admin-header>
<div class="ward-container">
    <app-admin-sidebar></app-admin-sidebar>
<h2>🏥 Ward Management</h2>

<form (ngSubmit)="saveWard()" class="form-inline">
  <input
    type="text"
    [(ngModel)]="newWard.name"
    name="name"
    required
    placeholder="Enter Ward Name"
  />
  <button type="submit">{{ editingWard ? 'Update Ward' : 'Add Ward' }}</button>
  <button type="button" *ngIf="editingWard" (click)="resetForm()">Cancel</button>
</form>

<hr />

<table>
  <thead>
    <tr>
      <th>#</th>
      <th>Ward Name</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let ward of wards; let i = index">
      <td>{{ i + 1 }}</td>
      <td>{{ ward.name }}</td>
      <td>
        <button (click)="editWard(ward)">Edit</button>
        <button (click)="deleteWard(ward.id)">Delete</button>
      </td>
    </tr>
  </tbody>
</table>
</div>